<template>
  <div class="brand-showcase" v-if="brand_is_show">
    <h2 class="showcase-title">战略合作伙伴</h2>
    <div class="marquee-container">
      <div class="semi-transparent-box"></div>
      <div 
        class="marquee-content"
        ref="marqueeRef"
      >
        <!-- 第一组图片 -->
        <div class="brand-logos">
          <img 
            :src="brandLogos" 
            alt="Brand Logos"
            class="logo-strip"
            @load="onImageLoad"
          >
        </div>
        <!-- 第二组图片（用于无缝衔接） -->
        <div class="brand-logos">
          <img 
            :src="brandLogos" 
            alt="Brand Logos"
            class="logo-strip"
          >
        </div>
        <div class="brand-logos">
          <img 
            :src="brandLogos" 
            alt="Brand Logos"
            class="logo-strip"
          >
        </div>
        <div class="brand-logos">
          <img 
            :src="brandLogos" 
            alt="Brand Logos"
            class="logo-strip"
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted, onUnmounted } from 'vue';
import { homeApi } from '@/api/home'; // 确保导入你的 API 模块

export default {
  setup() {
    const brandLogos = ref(null);
    const brand_is_show = ref(false);
    const marqueeRef = ref(null);

    const startAnimation = () => {
      if (marqueeRef.value) {
        marqueeRef.value.classList.add('animate');
      }
    };

    const onImageLoad = () => {
      startAnimation();
    };

    const fetchData = async () => {
      try {
        const response = await homeApi.getPartner();
        // 假设 response.data 包含你需要的数据
        const data = response.data;
        // console.log('data222',data.area_show)
        // 根据数据更新 brandLogos
       // 根据设备类型选择合适的图片 URL
       if (window.innerWidth <= 768) {
          // 移动端
          brandLogos.value = data.mobile_pic;
        } else {
          // PC端
          brandLogos.value = data.pc_pic;
        }
        brand_is_show.value = data.area_show == '1'
        // console.log('brand_is_show',brand_is_show.value)
        if (marqueeRef.value) {
          const img = new Image();
          img.src = brandLogos.value;
          if (img.complete) {
            startAnimation();
          }
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    onMounted(() => {
      fetchData();
    });

    onUnmounted(() => {
      if (marqueeRef.value) {
        marqueeRef.value.classList.remove('animate');
      }
    });

    return {
      marqueeRef,
      onImageLoad,
      brandLogos,
      brand_is_show
    };
  }
}
</script>

<style scoped>
.brand-showcase {
  width: 100%;
  height:500px;
  background-color: #000;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 60px 0;
  overflow: hidden;
}

.showcase-title {
  color: #fff;
  font-size: 42px;
  /* font-weight: 700; */
  margin-bottom: 60px;
  text-align: center;
}

.marquee-container {
  width:88vw;
  max-width: 1680px;
  overflow: hidden;
  position: relative;
}

.marquee-content {
  display: flex;
  position: relative;
}
.semi-transparent-box {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-image: radial-gradient(circle, transparent, transparent, #000);
    z-index: 10;
}
.brand-logos {
  flex-shrink: 0;
}

.logo-strip {
  display: block;
  height: auto;
  max-height: 120px;
  object-fit: contain;
}

/* 使用 CSS 动画替代 JavaScript 动画 */
@keyframes marquee {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-50%);
  }
}

.marquee-content.animate {
  animation: marquee 30s linear infinite; /* 增加动画时间到30秒 */
  will-change: transform;
}

/* 鼠标悬停时暂停动画 */
.marquee-container:hover .marquee-content.animate {
  animation-play-state: paused;
}

@media screen and (max-width: 768px) {
 
  .marquee-container{
    padding: 0 20px;
  }
  .brand-showcase {
    height: 240px;
    padding: 0 ;
  }

  .showcase-title {
    font-size: 24px;
    margin-bottom: 40px;
  }

  .logo-strip {
    max-height: 80px;
  }
}
</style>